import { InnerhivePlusText } from '../components/InnerhivePlusText';
import { PaywallAwareButton } from '../components/PaywallAwareButton';
import { createUseStyles } from 'react-jss';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useState } from 'react';
import { RevenueCatModel } from '../innerhive-plus/revenue-cat/RevenueCatModel';
import { CommunityInviteModal } from '../community/CommunityInviteModal';

const useStyles = createUseStyles({
    button: {
        height: 40
    }
});

export const InviteCoOwnerButton: React.FC = () => {
    const classes = useStyles();

    const revCat = useInstance(RevenueCatModel);

    const [isInviteModalOpen, setIsInviteModalOpen] = useState<boolean>(false);

    return (
        <>
            <PaywallAwareButton
                fill="outline"
                expand="block"
                data-id="invite-co-owner-button"
                className={classes.button}
                onClick={() => setIsInviteModalOpen(true)}
                triggerSource="co-owner invite"
                requiresInnerhivePlus={() => true}
                innerhivePlusMessage={<>Get <InnerhivePlusText/> to invite co-owners</>}
            >
                <>Invite Co-Owner</>
            </PaywallAwareButton>

            {revCat.hasInnerhivePlus() && (
                <CommunityInviteModal
                    isOpen={isInviteModalOpen}
                    access="co-owner"
                    closeHandler={() => setIsInviteModalOpen(false)}
                />
            )}
        </>
    );
};
